import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdministracionObjetivos } from '../models/administracion-objetivos';
import { ApiResult } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class AdministracionObjetivosService {

  constructor(protected http: HttpClient, @Inject('BASE_URL') protected baseUrl: string) { }
  
  getData( year: number, oficinaID: number ): Observable<ApiResult<AdministracionObjetivos>> {
  
    const url = this.baseUrl + 'api/AdministracionObjetivos';
  
    let params = new HttpParams()
      .set('year', year.toString())
      .set('idOficina', oficinaID.toString())
  
    return this.http.get<ApiResult<AdministracionObjetivos>>(url, { params });
  }

  put(item): Observable<AdministracionObjetivos> {
    const url = `${this.baseUrl}api/AdministracionObjetivos/${item.id}`;
    console.log("put: "+url);
    return this.http.put<AdministracionObjetivos>(url, item);
  }

  update( objetivo: AdministracionObjetivos): Observable<any> {
    //console.log(objetivo.OfFactId);
    return this.http.put(`${this.baseUrl}api/AdministracionObjetivos/${objetivo.year}/${objetivo.OfFactId}/${objetivo.month}`, objetivo);
  }

  updateAll( objetivos: AdministracionObjetivos): Observable<any> {
    //console.log(objetivo.OfFactId);
    return this.http.put(`${this.baseUrl}api/AdministracionObjetivos/post`, objetivos);
  }

  post(item): Observable<AdministracionObjetivos> {
    const url = `${this.baseUrl}api/AdministracionObjetivos`;
    console.log("post: "+url);
    return this.http.post<AdministracionObjetivos>(url, item);
  }

  delete(id: number) {
    const url = `${this.baseUrl}api/AdministracionObjetivos/${id}`;
    return this.http.delete<AdministracionObjetivos>(url);
  }

  getOficinasFacturacion() {
    return this.http.get(this.baseUrl + 'api/oficinaFacturacion/getDropDownList');
  }
}
